const myBookingsEN = {
	upcomingTitle: "Upcoming",
	upcomingSubLoading: "Loading...",
	upcomingSubCount: (count) => `${count} confirmed`,
	noUpcoming: "No upcoming bookings",
	emailSent: "Email sent",
	addToCalendar: "Add to Calendar",
	reschedule: "Reschedule",
	cancel: "Cancel",

	historyTitle: "History",
	historySub: "Your past visits",
	noHistory: "No past visits yet",

	table: {
		date: "Date",
		service: "Service",
		shop: "Shop",
		status: "Status",
	},

	errors: {
		load: "We couldn't load your bookings. Please try again.",
		cancel: "We couldn't cancel your booking. Please try again.",
		reload: "We couldn't refresh your bookings.",
		reschedule: "We couldn't open rescheduling. Please try again.",
	},
};

export default myBookingsEN;
